"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PointsAndLabelsWrapper = exports.Points = exports.Deal = void 0;
var _mui = require("@ori-ui/mui");
var _presentationComponents = require("@ori/presentation-components");
var _presentationUtils = require("@ori/presentation-utils");
const PointsAndLabelsWrapper = exports.PointsAndLabelsWrapper = (0, _mui.styled)('div')({
  display: 'flex',
  flexDirection: 'column',
  position: 'absolute',
  top: 0,
  width: '100%'
});
const Points = exports.Points = (0, _mui.styled)('div', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  theme,
  background
}) => ({
  alignItems: 'center',
  background: background === 'dark' ? theme.palette.primary.main : theme.palette.grey[200],
  borderRadius: '50%',
  color: background === 'dark' ? theme.palette.text.primary : theme.palette.grey.A400,
  display: 'flex',
  fontSize: '1.4rem',
  fontWeight: theme.typography.fontWeightBold,
  height: 35,
  justifyContent: 'center',
  left: 10,
  position: 'absolute',
  top: 10,
  width: 35,
  zIndex: 1,
  [theme.breakpoints.up('sm')]: {
    fontSize: '1.8rem',
    height: 45,
    width: 45
  }
}));
const Deal = exports.Deal = (0, _mui.styled)(_presentationComponents.DealLabel)(({
  theme
}) => ({
  margin: theme.spacing(3, 3, 0, 3)
}));
